import { isPlatformBrowser } from "@angular/common";
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse, HttpHeaders } from "@angular/common/http";
import { Inject, Injectable, PLATFORM_ID } from "@angular/core";
import { Router } from "@angular/router";
// import { CookieService } from "ngx-cookie";
import { BehaviorSubject, Observable, Subject, throwError } from "rxjs";
import { tap, map, catchError, switchMap, filter, take } from 'rxjs/operators'
import { BehaviorDataService } from "../api-integration-files/behavior-data.service";
import { CookieService } from "../api-integration-files/cookie.service";
import { SharedService } from "../api-integration-files/shared.service";
import { RootService } from "../auth/root.service";
import { secureStorage } from "../encryption/securestorage";
import { environment } from "../../../../environments/environment";
@Injectable()

export class APIHttpInterceptor implements HttpInterceptor {

    /** Emitted to waiters when a refresh fails, so they unblock instead of hanging. */
    private static readonly REFRESH_FAILED = 'refresh-failed';

    private isRefreshing = false;
    private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    freeaccessToken:any
    freerefreshToken:any;
    isLoggedIn: boolean = false;
    private FreeTokenInProgress = false;
    private FreeTokenSubject: Subject<any> = new BehaviorSubject<any>(null);
    private FreeRefreshTokenInProgress = false;
    private FreeRefreshTokenSubject: Subject<any> = new BehaviorSubject<any>(null);
    constructor(
        private localStorage: secureStorage,
        private sharedService: SharedService,
        private rootService: RootService,
        //nonssr
      //  private cookieService: CookieService,
       //ssr
       private ssrcookieService: CookieService,
        private behaviorService :BehaviorDataService,
        @Inject(PLATFORM_ID) private platformId: Object,) { }

    injectToken(request: HttpRequest<any>) {
        // let isLoggedIn = this.rootService.isUserLoggedIn();
        const userCode  :any = this.rootService.getUserCode() ? this.rootService.getUserCode() : null;
        // const accessToken :any = this.cookieService.getObject('access_token') ? this.cookieService.getObject('access_token') : null;
        const accessToken :any = this.ssrcookieService.getItem('access_token') ? this.ssrcookieService.getItem('access_token') : null;
        this.behaviorService.freeSearchTokenUpdated.subscribe((val:any) => {

        //  this.freeaccessToken = this.cookieService.getObject('free_access_token') ? this.cookieService.getObject('free_access_token') : null;
        // this.freerefreshToken = this.cookieService.getObject('free_ref_token') ? this.cookieService.getObject('free_ref_token') : this.localStorage.getItem('free_ref_token');
        this.freeaccessToken = this.ssrcookieService.getItem('free_access_token') ? this.ssrcookieService.getItem('free_access_token') : null;
        this.freerefreshToken = this.ssrcookieService.getItem('free_ref_token') ? this.ssrcookieService.getItem('free_ref_token') : this.localStorage.getItem('free_ref_token');
      })

        if(request.url.includes('geo_dropdown') || request.url.includes('FreeSearchTokenRequest')){
        if (this.freeaccessToken && this.freerefreshToken) {
            return request.clone({
                setHeaders: {
                    // 'user-code': userCode,
                    Authorization: `Bearer ${this.freeaccessToken}`,
                    'X-Client-Channel': 'website',
                    'X-Client-Platform': 'desktop'
                },
            });
        }
        else {
            return request;
        }
        }else{
        if (accessToken && userCode) {

            return request.clone({
                setHeaders: {
                    'user-code': userCode,
                    Authorization: `Bearer ${accessToken}`,
                    // So CORE can record UserVehicle.created_via_channel /
                    // created_via_platform at creation time — this app is
                    // the public self-service site, web-only, so both are
                    // constants.
                    'X-Client-Channel': 'website',
                    'X-Client-Platform': 'desktop'
                },
            });

        }
        else {
            return request;
        }
    }
    }
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        // In the browser the session lives in HttpOnly cookies held by the
        // site's own server (bff.ts, VAPT: HttpOnly/SameSite): API calls go to
        // it on this origin, carry no token, and it signs them. The token
        // logic below is now only the server render's, which reads the same
        // cookies from the request headers.
        if (isPlatformBrowser(this.platformId)) {
            if (request.url.startsWith('/bff/')) {
                return next.handle(request);
            }
            if (request.url.startsWith(environment.httpPort)) {
                return this.viaBff(request, next);
            }
        }

        if (request.url.indexOf('refresh') !== -1) {
            return next.handle(this.injectToken(request)).pipe(catchError(this.handleError));
        }

        // const accessToken = this.cookieService.getObject('access_token') ? this.cookieService.getObject('access_token') : null ;
        // const refreshToken = this.cookieService.getObject('ref_token') ? this.cookieService.getObject('ref_token') : null;

        const accessToken = this.ssrcookieService.getItem('access_token') ? this.ssrcookieService.getItem('access_token') : null ;
        const refreshToken = this.ssrcookieService.getItem('ref_token') ? this.ssrcookieService.getItem('ref_token') : null;
        //for freesearch token
        // const accessExpired :any = this.cookieService.getObject('free_access_token') ? this.cookieService.getObject('free_access_token') : null;
        // const refreshExpired  :any= this.cookieService.getObject('free_ref_token') ? this.cookieService.getObject('free_ref_token')  :  this.localStorage.getItem('free_ref_token');

        const accessExpired :any = this.ssrcookieService.getItem('free_access_token') ? this.ssrcookieService.getItem('free_access_token') : null;
        const refreshExpired  :any= this.ssrcookieService.getItem('free_ref_token') ? this.ssrcookieService.getItem('free_ref_token')  :  this.localStorage.getItem('free_ref_token');


        if(request.url.includes('geo_dropdown') || request.url.includes('FreeSearchTokenRequest')){
            if (accessExpired && refreshExpired) {
                return next.handle(this.injectToken(request)).pipe(catchError(this.handleError));
              }
              if (!accessExpired && !refreshExpired) {
                if (!this.FreeTokenInProgress) {
                  this.FreeTokenInProgress = true;
                  this.FreeTokenSubject.next(null);
                } else {
                  this.isLoggedIn = this.rootService.isUserLoggedIn();
                  if (this.isLoggedIn) {
                    if (!this.FreeRefreshTokenInProgress) {
                      this.FreeRefreshTokenInProgress = true;
                      this.FreeRefreshTokenSubject.next(null);
                      if (!accessExpired) {
                        if (
                          this.localStorage.getItem('FreeRefreshTokenInProgress') != 'true'
                        ) {
                          this.localStorage.setItem('FreeRefreshTokenInProgress', 'true');
                          let res :any = this.rootService.refreshToken2();
                          return res.pipe(
                            switchMap((authResponse:any) => {
                              if (authResponse) {
                                this.FreeRefreshTokenInProgress = false;
                              }
                              this.FreeRefreshTokenSubject.next(
                                authResponse.data.refresh_token
                              );

                              return next.handle(this.injectToken(request)).pipe(catchError(this.handleError));
                            })
                          );
                        }
                      } else {
                      }
                    } else {
                      if (!accessExpired) {
                        if (
                          this.localStorage.getItem('FreeRefreshTokenInProgress') != 'true'
                        ) {
                          this.localStorage.setItem('FreeRefreshTokenInProgress', 'true');
                          // return
                           this.rootService.refreshToken2();
                        }
                      }
                    }
                  } else {
        if (isPlatformBrowser(this.platformId)) {

                    window.location.reload();
        }
                  }
                }
              }
              if (!accessExpired && refreshExpired) {
                if (!this.FreeRefreshTokenInProgress) {
                  this.FreeRefreshTokenInProgress = true;
                  this.FreeRefreshTokenSubject.next(null);
                  if (!accessExpired) {
                    if (this.localStorage.getItem('FreeRefreshTokenInProgress') != 'true') {
                      this.localStorage.setItem('FreeRefreshTokenInProgress', 'true');
                      let res :any = this.rootService.refreshToken2();
                          return res.pipe(switchMap((authResponse:any) => {
                          if (authResponse) {
                            this.FreeRefreshTokenInProgress = false;
                          }
                          this.FreeRefreshTokenSubject.next(authResponse.data.refresh_token);
                          return next.handle(this.injectToken(request)).pipe(catchError(this.handleError));
                        })
                      );
                    }
                  } else {
                  }
                } else {
                  return this.FreeRefreshTokenSubject.pipe(
                    filter((result) => result !== null),
                    take(1),
                    switchMap((res) => {
                      return next.handle(this.injectToken(request)).pipe(catchError(this.handleError));
                    })
                  );
                }
              }
              if (!accessExpired) {
                return next.handle(this.injectToken(request)).pipe(catchError(this.handleError));
              }
        }
        else{

          //normal token
        if (accessToken && refreshToken) {
            return next.handle(this.injectToken(request)).pipe(catchError(this.handleError));
        }
        if (!accessToken && !refreshToken) {
            let isLoggedIn = this.rootService.isUserLoggedIn();;
            if (isLoggedIn) {

              this.sharedService.logout();


    // if (isPlatformBrowser(this.platformId)) {

                // this.localStorage.clear();
                // this.cookieService.removeAll();
    // }
                // if (!this.isRefreshing) {
                //     this.isRefreshing = true;
                //     this.refreshTokenSubject.next(null);
                //     return this.rootService.refreshToken().pipe(
                //         switchMap((authResponse: any) => {
                //             this.isRefreshing = false;
                //             this.refreshTokenSubject.next(authResponse.data.refresh_token);
                //             return next.handle(this.injectToken(request)).pipe(catchError(this.handleError));
                //         }));
                // }
            } else {
                return next.handle(this.injectToken(request)).pipe(catchError(this.handleError));
            }
        }
        if (!accessToken && refreshToken) {
            if (!this.isRefreshing) {
                this.isRefreshing = true;
                this.refreshTokenSubject.next(null);
                return this.rootService.refreshToken().pipe(
                    switchMap((authResponse: any) => {
                        this.isRefreshing = false;
                        this.refreshTokenSubject.next(authResponse.data.refresh_token);
                        return next.handle(this.injectToken(request)).pipe(catchError(this.handleError));
                    }),
                    // A refresh that fails used to leave `isRefreshing` true for
                    // the lifetime of the page: every later request then took the
                    // branch below and waited on a subject that could never emit,
                    // so it hung silently and never reached the server. That is
                    // what made Logout do nothing once the stored refresh token
                    // had gone stale -- the POST was queued behind a refresh that
                    // had already failed. Release the gate, drop the dead session
                    // and let the caller see the error.
                    catchError((err) => {
                        this.isRefreshing = false;
                        this.refreshTokenSubject.next(APIHttpInterceptor.REFRESH_FAILED);
                        this.sharedService.logout();
                        return throwError(() => err);
                    })
                );
            }
            else {
                return this.refreshTokenSubject.pipe(
                    filter((token) => token !== null),
                    take(1),
                    switchMap((token) => {
                        // REFRESH_FAILED passes the filter on purpose: the queued
                        // request is released to fail on its own rather than hang
                        // for as long as the tab is open.
                        return next.handle(this.injectToken(request)).pipe(catchError(this.handleError));
                    })
                );
            }
        }
        if (!accessToken) {
            return next.handle(this.injectToken(request)).pipe(catchError(this.handleError))
        }
    }
        return next.handle(this.injectToken(request)).pipe(catchError(this.handleError));


    }

    /** environment.httpPort/... -> /bff/..., unsigned; see intercept(). */
    private viaBff(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const headers: Record<string, string> = {
            'X-Client-Channel': 'website',
            'X-Client-Platform': 'desktop',
        };
        const userCode = this.rootService.getUserCode();
        if (userCode && this.rootService.sessionAlive()) {
            headers['user-code'] = userCode;
        }
        const proxied = request.clone({
            url: '/bff' + request.url.slice(environment.httpPort.length),
            setHeaders: headers,
        });
        return next.handle(proxied).pipe(
            tap((event) => {
                if (event instanceof HttpResponse) {
                    this.noteSession(event.headers);
                }
            }),
            catchError((error: HttpErrorResponse) => {
                this.noteSession(error.headers);
                return this.handleError(error);
            }),
        );
    }

    /**
     * The server says when the session it holds now lasts until (it moves on
     * every refresh), or that it has ended -- in which case the app's own
     * signed-in state goes too, as it did when the refresh failed here.
     */
    private noteSession(headers?: HttpHeaders): void {
        if (!headers) {
            return;
        }
        const expires = Number(headers.get('X-BFF-Session-Expires'));
        if (expires > 0) {
            this.rootService.noteSessionExpiry(expires);
        }
        if (headers.get('X-BFF-Session') === 'expired' && this.rootService.getUserCode()) {
            this.sharedService.logout();
        }
    }

    handleError(error: HttpErrorResponse) {

        let data: any = {};
            let errorMsg = 'Something went wrong, Please try again !';
            data = {
            // Backend errors carry their text at error.error.data.msg (see
            // account_helper.py's response shape). Anything else -- a network
            // failure, a proxy/WAF page that isn't JSON, a response with no
            // `data` key -- has no usable string there, so fall back to
            // errorMsg. This used to fall back to the raw `error` object
            // itself, which a caller then handed straight to
            // failedSnackBarResponse(); MatSnackBar's default template just
            // interpolates {{data.message}}, and interpolating an object
            // renders literally "[object Object]" -- the toast this replaces.
            msg: (typeof error?.error?.data?.msg === 'string' && error.error.data.msg) ? error.error.data.msg : errorMsg,
            status: error.status,
            apierror : error,
            // netWorkStatus: window.navigator.onLine
            netWorkStatus: true
        };
// if( data.msg == 'Authentication credentials were expired.'){
//     this.sharedService.logout();
// }
//         // this.errorDialogService.openDialog(data);
//         if (error.status === 401) {
//     if (isPlatformBrowser(this.platformId)) {

//             this.localStorage.clear();
//             throw data;
//     }
//         }
        if(error.status === 0 || error.status === 500 ){
            data.msg = 'Something went wrong, Please try again !'
             return throwError(data);
          }
        if(!data.netWorkStatus){
            data.msg = "You are Offline.Please check the network connectivity";
            return throwError(data);
        }
        return throwError(data);
    }


}


